import React from "react";
import ElectionRegister from "./ElectionRegister";

const ElectionForm = () => {
  return (
    <>
      <ElectionRegister />
    </>
  );
};

export default ElectionForm;
